export default [
  {
    en: 'Product Line',
    es: 'Línea de Productos'
  },
  {
    en: 'Fixture Mount',
    es: 'Montaje de Mueble de Baño'
  },
  {
    en: 'Fixture Connection',
    es: 'Conexión de Mueble de Baño'
  },
  {
    en: 'Flush Volume',
    es: 'Volumen de Descarga'
  },
  {
    en: 'Compliances',
    es: 'Cumplimientos'
  },
  {
    en: 'Compliances & Certifications',
    es: 'Cumplimientos y Certificaciones'
  },
  {
    en: 'Carbon Offset',
    es: 'Compensación de Carbono'
  },
  {
    en: 'Power',
    es: 'Energía'
  },
  {
    en: 'Power Type',
    es: 'Tipo de Energía'
  },
  {
    en: 'Sensor Type',
    es: 'Tipo de Sensor'
  },
  {
    en: 'Flow Rate',
    es: 'Índice de Flujo'
  },
  {
    en: 'Body Type',
    es: 'Tipo de Cuerpo'
  },
  {
    en: 'Mixer',
    es: 'Mezcladora'
  },
  {
    en: 'Mounting',
    es: 'Montaje'
  },
  {
    en: 'Mounting Type',
    es: 'Tipo de Montaje'
  },
  {
    en: 'Trim Plate (in)',
    es: 'Placa de Montaje (pulg)'
  },
  {
    en: 'Control Access',
    es: 'Acceso de Control'
  },
  {
    en: 'Finish',
    es: 'Acabado'
  },
  {
    en: 'Spray Type',
    es: 'Tipo de Rocío'
  },
  {
    en: 'Spout Design',
    es: 'Diseño de Caño'
  },
  {
    en: 'Spout Type',
    es: 'Tipo de Grifo'
  },
  {
    en: 'Centerset',
    es: 'Juego Centrado'
  },
  {
    en: 'Adapter',
    es: 'Adaptador'
  },
  {
    en: 'Transformer',
    es: 'Transformador'
  },
  {
    en: 'Timeout',
    es: 'Pausa'
  },
  {
    en: 'Wash Station',
    es: 'Estación de Lavado'
  },
  {
    en: 'Water Control',
    es: 'Control de Agua'
  },
  {
    en: 'Special Features',
    es: 'Características Especiales'
  },
  {
    en: 'Soap Type',
    es: 'Tipo de Jabón'
  },
  {
    en: 'Flush Volume (gpf)',
    es: 'Volumen de Descarga (gpd)'
  },
  {
    en: 'Activation',
    es: 'Activación'
  },
  {
    en: 'Valve',
    es: 'Válvula'
  },
  {
    en: 'Installation',
    es: 'Instalación'
  },
  {
    en: 'Fixture Type',
    es: 'Tipo de Mueble de Baño'
  },
  {
    en: 'Sensor Line',
    es: 'Línea de Sensor'
  },
  {
    en: 'Override',
    es: 'Sobrepaso'
  },
  {
    en: 'Standard',
    es: 'Estándar'
  },
  {
    en: 'Hydraulic',
    es: 'Hidráulico'
  },
  {
    en: 'Specialty',
    es: 'Especialidad'
  },
  {
    en: 'Reclaimed Water',
    es: 'Agua Recuperada'
  },
  {
    en: 'Valve Body Material',
    es: 'Valve Body Material'
  },
  {
    en: 'Bypass',
    es: 'Sobrepaso'
  },
  {
    en: 'L Dimension',
    es: 'Dimensión L'
  },
  {
    en: 'Wall Box',
    es: 'Caja de Muro'
  },
  {
    en: 'Handle',
    es: 'Manija'
  },
  {
    en: 'Push Button',
    es: 'Botón'
  },
  {
    en: 'Water Efficiency',
    es: 'Eficiencia en el Consumo de Agua'
  },
  {
    en: 'High Efficiency',
    es: 'Alta Eficiencia'
  },
  {
    en: 'Control Stop',
    es: 'Válvula de Retención'
  },
  {
    en: 'Tailpiece',
    es: 'Boquilla'
  },
  {
    en: 'Inlet',
    es: 'Entrada'
  },
  {
    en: 'Vacuum Breaker',
    es: 'Rompe-Vacío'
  },
  {
    en: 'Offset (in)',
    es: 'Compensación (pulg)'
  },
  {
    en: 'Outlet Tube',
    es: 'Outlet Tube'
  },
  {
    en: 'Fitting',
    es: 'Conector'
  },
  {
    en: 'Bumper',
    es: 'Tope'
  },
  {
    en: 'Pipe Support',
    es: 'Soporte de Tubo'
  },
  {
    en: 'Voltage',
    es: 'Voltaje'
  },
  {
    en: 'Wattage',
    es: 'Vataje'
  },
  {
    en: 'Configuration',
    es: 'Configuración'
  },
  {
    en: 'SloanTec® Hydrophobic Glaze',
    es: 'Esmalte Hidrorepelente SloanTec®'
  },
  {
    en: 'Floor Mount Type',
    es: 'Tipo de Montaje al Piso'
  },
  {
    en: 'Type',
    es: 'Tipo'
  },
  {
    en: 'Smart Faucet',
    es: 'Grifo Inteligente'
  },
  {
    en: 'PWT',
    es: 'PWT'
  },
  {
    en: 'Set Screws Included',
    es: 'Tornillos de Ajuste Incluidos'
  },
  {
    en: 'Stations',
    es: 'Estaciones'
  },
  {
    en: 'Variable Size',
    es: 'Tamaño Variable'
  },
  {
    en: 'Verticals',
    es: 'Verticales'
  },
  {
    en: 'Building Types',
    es: 'Tipos de Edificios'
  },
  {
    en: 'Dispenser Type',
    es: 'Tipo de Despachador'
  },
  {
    en: 'Flush Method',
    es: 'Método de Descarga'
  },
  {
    en: 'Urinal Type',
    es: 'Tipo de Mingitorio'
  },
  {
    en: 'Retrofit',
    es: 'Retrofit'
  },
  {
    en: 'Brushed Nickel',
    es: 'Niquel Pulido'
  },
  {
    en: 'Brushed Stainless',
    es: 'Cepillado Inoxidable'
  },
  {
    en: 'Graphite',
    es: 'Grafito'
  },
  {
    en: 'Polished Brass',
    es: 'Latón Pulido'
  },
  {
    en: 'Polished Chrome',
    es: 'Cromo Pulido'
  },
  {
    en: 'Quick Actions',
    es: 'Atajos rápida'
  },
  {
    en: 'As low as',
    es: 'Tan bajo como'
  },
  {
    en: 'Discontinued',
    es: 'Descontinuado'
  },
  {
    en: 'List Price',
    es: 'Precio de lista'
  },
  {
    en: 'Not available for US and Canada',
    es: 'No disponible para US & Canadá'
  },
  {
    en: 'Download Spec',
    es: 'Descargar Especificacion'
  },
  {
    en: 'Share Spec',
    es: 'Compartir especificaciones'
  },
  {
    en: 'White Papers Access failed. Please try again.',
    es: 'Error de acceso a los Reportes Técnicos. Por favor inténtelo de nuevo.'
  },
  {
    en: 'Yes',
    es: 'Sí'
  },
  {
    en: 'Choose',
    es: 'Escoger'
  },
  {
    en: 'Loading...',
    es: 'Cargando...'
  },
  {
    en: 'Add a product',
    es: 'Agregar un producto'
  },
  {
    en: 'Title (A → Z)',
    es: 'Título (A → Z)'
  },
  {
    en: 'Title (Z → A)',
    es: 'Título (Z → A)'
  },
  {
    en: 'Price (Low → High)',
    es: 'Precio (Bajo → Alto)'
  },
  {
    en: 'Price (High → Low)',
    es: 'Precio (Alto → Bajo)'
  },
  {
    en: 'Cover Image',
    es: 'Imagen de Portada'
  },
  {
    en: 'My Profile',
    es: 'Mi Perfil'
  },
  {
    en: 'My DesignSpec Projects',
    es: 'Mis Proyectos de Especificaciones de Diseño'
  },
  {
    en: 'Login',
    es: 'Iniciar Sesión'
  },
  {
    en: 'Create an Account',
    es: 'Crear una Cuenta'
  },
  {
    en: 'My Projects',
    es: 'Mis Proyectos'
  },
  {
    en: 'Download DesignSpec',
    es: 'Descargar Especificaciones de Diseño'
  },
  {
    en: 'Edit',
    es: 'Editar'
  },
  {
    en: 'Preview',
    es: 'Vista Previa'
  },
  {
    en: 'Share',
    es: 'Compartir'
  },
  {
    en: 'Project Details',
    es: 'Detalles del Proyecto'
  },
  {
    en: 'Update project cover image and keep notes here.',
    es: 'Actualizar la imagen de portada del proyecto y guardar notas aquí.'
  },
  {
    en: 'New Section',
    es: 'Nueva Sección'
  },
  {
    en: 'Section Name',
    es: 'Nombre de la Sección'
  },
  {
    en: 'Empty',
    es: 'Vacío'
  },
  {
    en: 'Welcome to DesignSpec',
    es: 'Bienvenido a Especificaciones de Diseño'
  },
  {
    en: 'Quickly and easily build a commercial restroom spec package with any Sloan products.',
    es: 'Cree rápida y fácilmente un paquete de especificaciones para baños comerciales con cualquier producto Sloan.'
  },
  {
    en: 'Add products from anywhere on the site',
    es: 'Agregar productos desde cualquier lugar del sitio'
  },
  {
    en: 'Organize products into sections',
    es: 'Organizar productos en secciones'
  },
  {
    en: 'Include Spec Sheets and BIM Models in your project',
    es: 'Incluir Hojas de Especificaciones y Modelos BIM en su proyecto'
  },
  {
    en: 'Share, print, or download your packaged DesignSpec',
    es: 'Compartir, imprimir o descargar su paquete de Especificaciones de Diseño'
  },
  {
    en: 'Select a project',
    es: 'Seleccione un proyecto'
  },
  {
    en: 'Add to section(s)',
    es: 'Agregar a sección(es)'
  },
  {
    en: 'I understand, continue',
    es: 'Entiendo, continuar'
  },
  {
    en: 'Add',
    es: 'Agregar'
  },
  {
    en: 'Create a DesignSpec',
    es: 'Crear una Especificaciones de Diseño'
  },
  {
    en: 'Spec Name',
    es: 'Nombre de la Especificación'
  },
  {
    en: 'e.g. “Coworking Space”',
    es: 'p.ej. “Espacio de trabajo conjunto”'
  },
  {
    en: 'products',
    es: 'productos'
  },
  {
    en: 'will be imported from',
    es: 'será importado de'
  },
  {
    en: 'Cancel',
    es: 'Cancelar'
  },
  {
    en: 'Create',
    es: 'Crear'
  },
  {
    en: 'You have already started a Design Spec project,',
    es: 'Ya ha iniciado un proyecto de Especificación de Diseño,'
  },
  {
    en: 'Creating a new project will override your existing spec.',
    es: 'La creación de un nuevo proyecto anulará su especificación existente.'
  },
  {
    en: 'To save your existing project, manage multiple projects, or share your specs with others,',
    es: 'Para guardar su proyecto existente, administrar varios proyectos o compartir sus especificaciones con otros,'
  },
  {
    en: 'Log In',
    es: 'Iniciar Sesión'
  },
  {
    en: 'Create new project',
    es: 'Crear nuevo proyecto'
  },
  {
    en: 'Go to existing project',
    es: 'Ir al proyecto existente'
  },
  {
    en: 'Sloan DesignSpec',
    es: 'Especificaciones de Diseño de Sloan'
  },
  {
    en: 'Please log in or create an account to continue.',
    es: 'Inicie sesión o cree una cuenta para continuar.'
  },
  {
    en: 'Add Products to',
    es: 'Agregar Productos a'
  },
  {
    en: 'Download',
    es: 'Descarga'
  },
  {
    en: 'Spec',
    es: 'Especificación'
  },
  {
    en: 'Your spec will be prepared as a .zip package for download.',
    es: 'Su especificación se preparará como un paquete .zip para su descarga.'
  },
  {
    en: 'Select additional files to include for each product in your DesignSpec package:',
    es: 'Seleccione archivos adicionales para incluir para cada producto en su paquete de Especificaciones de Diseño:'
  },
  {
    en: 'Edit Cover Image',
    es: 'Editar Imagen de Portada'
  },
  {
    en: 'Save',
    es: 'Guardar'
  },
  {
    en: 'Edit Project Details',
    es: 'Editar Detalles del Proyecto'
  },
  {
    en: 'Project Name',
    es: 'Nombre del Proyecto'
  },
  {
    en: 'My Project',
    es: 'Mi Proyecto'
  },
  {
    en: 'Project Notes',
    es: 'Notas del Proyecto'
  },
  {
    en: 'Location',
    es: 'Ubicación'
  },
  {
    en: 'Firm Name',
    es: 'Nombre de la Firma'
  },
  {
    en: 'e.g. “SOM Architects”',
    es: 'p.ej. “SOM Architects”'
  },
  {
    en: 'Address',
    es: 'Dirección'
  },
  {
    en: 'e.g. “123 Michigan Ave, Suite 100”',
    es: 'p.ej. “123 Michigan Ave, Suite 100”'
  },
  {
    en: 'City',
    es: 'Ciudad'
  },
  {
    en: 'e.g. “Chicago”',
    es: 'p.ej. “Chicago”'
  },
  {
    en: 'State',
    es: 'Estado'
  },
  {
    en: 'Zip',
    es: 'Código Postal'
  },
  {
    en: 'e.g. 60606',
    es: 'p.ej. 60606'
  },
  {
    en: 'Add Recipients',
    es: 'Agregar Destinatarios'
  },
  {
    en: 'Enter email address',
    es: 'Introduzca la dirección de correo electrónico'
  },
  {
    en: 'Add a message for your recipients (optional)',
    es: 'Agregar un mensaje para sus destinatarios (opcional)'
  },
  {
    en: 'Sharing...',
    es: 'Compartiendo...'
  },
  {
    en: 'To share your custom Sloan DesignSpec, log in or create an account.',
    es: 'Para compartir su Especificaciones de Diseño personalizada de Sloan, inicie sesión o cree una cuenta.'
  },
  {
    en: 'DesignSpec has been shared',
    es: 'Especificaciones de Diseño ha sido compartido'
  },
  {
    en: 'An email has been sent with a link to your project',
    es: 'Se ha enviado un correo electrónico con un enlace a su proyecto'
  },
  {
    en: 'Sloan Account',
    es: 'Cuenta de Sloan'
  },
  {
    en: 'Log in to save your custom Sloan DesignSpec, create new specs, and manage multiple projects.',
    es: 'Inicie sesión para guardar su Especificaciones de Diseño personalizada de Sloan, crear nuevas especificaciones y administrar varios proyectos.'
  },
  {
    en: 'Create a Sloan account to experience more of what Sloan can offer. You’ll be able to save products to your Sloan DesignSpec and manage future projects.',
    es: 'Cree una cuenta de Sloan para experimentar más de lo que Sloan puede ofrecer. Podrá guardar productos en su Especificaciones de Diseño de Sloan y administrar proyectos futuros.'
  },
  {
    en: 'Select an account',
    es: 'Seleccione una cuenta'
  },
  {
    en: 'Log in to your Sink Configurator, DesignSpec, or Sloan Training Center account.',
    es: 'Inicie sesión en su cuenta Sink Configurator, Especificaciones de Diseño o Centro de Formación de Sloan.'
  },
  {
    en: 'DesignSpec',
    es: 'Especificaciones de Diseño'
  },
  {
    en: 'Save your custom Sloan DesignSpec, create new specs, and manage multiple projects.',
    es: 'Guarde su Especificaciones de Diseño personalizada de Sloan, cree nuevas especificaciones y administre varios proyectos.'
  },
  {
    en: 'Sloan Training Center',
    es: 'Centro de Formación de Sloan'
  },
  {
    en: 'Learn about Sloan’s products and solutions from any where at any time.',
    es: 'Aprenda sobre los productos y soluciones de Sloan desde cualquier lugar y en cualquier momento.'
  },
  {
    en: 'Save changes',
    es: 'Guardar cambios'
  },
  {
    en: 'Welcome to your Sloan account! Manage your account details on this page.',
    es: '¡Bienvenido a su cuenta de Sloan! Administre los detalles de su cuenta en esta página.'
  },
  {
    en: 'General Information',
    es: 'Información General'
  },
  {
    en: 'Full Name',
    es: 'Nombre Completo'
  },
  {
    en: 'e.g. Jane Smith',
    es: 'p.ej. Jane Smith'
  },
  {
    en: 'Email',
    es: 'Correo Electrónico'
  },
  {
    en: 'Organization',
    es: 'Organización'
  },
  {
    en: 'e.g. SOM Architects',
    es: 'p.ej. SOM Architects'
  },
  {
    en: 'Title',
    es: 'Título'
  },
  {
    en: 'e.g. Lead Architect',
    es: 'p.ej. Arquitecto Principal'
  },
  {
    en: 'Add a section',
    es: 'Agregar una sección'
  },
  {
    en: 'Create new Sloan DesignSpec',
    es: 'Crear nueva Especificaciones de Diseño de Sloan'
  },
  {
    en: 'Search Projects',
    es: 'Buscar Proyectos'
  },
  {
    en: 'Date Created',
    es: 'Fecha de Creación'
  },
  {
    en: 'You have not created any projects yet!',
    es: '¡Aún no ha creado ningún proyecto!'
  },
  {
    en: 'No results',
    es: 'No se resultados'
  },
  {
    en: 'No results found',
    es: 'No se encontraron resultados'
  },
  {
    en: 'Page not found',
    es: 'Página no encontrada'
  },
  {
    en: 'Sorry about that! Click',
    es: '¡Lo sentimos! Haga clic'
  },
  {
    en: 'here',
    es: 'aquí'
  },
  {
    en: 'to return to the home page.',
    es: 'para volver a la página de inicio.'
  },
  {
    en: 'My DesignSpec',
    es: 'Mi Especificaciones de Diseño'
  },
  {
    en: 'My Sink Configurations',
    es: 'Mis Configuraciones de Lavabo'
  },
  {
    en: 'Show more',
    es: 'Mostrar más'
  },
  {
    en: 'Show less',
    es: 'Mostrar menos'
  },
  {
    en: 'Division 22 Plumbing',
    es: 'División 22 Plomería'
  },
  {
    en: 'Division 10 Specialties',
    es: 'División 10 Especialidades'
  },
  {
    en: 'Add a',
    es: 'Agregar un'
  },
  {
    en: 'to DesignSpec',
    es: 'a Especificaciones de Diseño'
  },
  {
    en: 'selected',
    es: 'seleccionado'
  },
  {
    en: 'Product',
    es: 'Producto'
  },
  {
    en: 'Added to DesignSpec',
    es: 'Agregado a Especificaciones de Diseño'
  },
  {
    en: 'has been added to',
    es: 'se ha agregado a'
  },
  {
    en: 'Open in DesignSpec',
    es: 'Abrir en Especificaciones de Diseño'
  },
  {
    en: 'Hide',
    es: 'Esconder'
  },
  {
    en: 'View',
    es: 'Mostrar'
  },
  {
    en: 'all filters',
    es: 'todos los filtros'
  },
  {
    en: 'Matching Variations',
    es: 'Variaciones Coincidentes'
  },
  {
    en: 'General Model',
    es: 'Modelo General'
  },
  {
    en: 'All Variations',
    es: 'Todas las Variaciones'
  },
  {
    en: 'Replaced by',
    es: 'Reemplazado por'
  },
  {
    en: 'Compliances & Certifications',
    es: 'Cumplimientos y Certificaciones'
  },
  {
    en: 'Model Spec',
    es: 'Especificaciones del Modelo'
  },
  {
    en: 'Add to DesignSpec',
    es: 'Agregar a Especificaciones de Diseño'
  },
  {
    en: '† The brands and/or products names referenced herein may be subject to trademark rights of their respective owners. Use of the brands and names is for identification purposes only and does not imply affiliation with or endorsement by Sloan.',
    es: '† Las marcas y/o nombres de productos a los que se hace referencia en este documento pueden estar sujetos a los derechos de marca registrada de sus respectivos propietarios. El uso de las marcas y los nombres es únicamente con fines de identificación y no implica afiliación ni respaldo por parte de Sloan.'
  },
  {
    en: 'View More Variations',
    es: 'Mostrar Más Variaciones'
  },
  {
    en: 'Downloading...',
    es: 'Descargando...'
  },
  {
    en: 'Downloaded!',
    es: '¡Descargado!'
  },
  {
    en: 'Download failed.',
    es: 'Error al descargar.'
  },
  {
    en: 'result',
    es: 'resultado'
  },
  {
    en: 'Search Sloan’s extensive image library to inspire your next project',
    es: 'Busque en la extensa biblioteca de imágenes de Sloan para inspirar su próximo proyecto'
  },
  {
    en: 'View Products in rendering',
    es: 'Mostrar productos en renderizado'
  },
  {
    en: 'Search for images...',
    es: 'Buscar imágenes...'
  },
  {
    en: 'Not available for US and Canada',
    es: 'No disponible para EE. UU. y Canadá'
  },
  {
    en: 'No image results found',
    es: 'No se encontraron resultados de imágenes'
  },
  {
    en: 'This item has no featured products',
    es: 'Este elemento no tiene productos destacados'
  },
  {
    en: 'Something went wrong while fetching featured products.',
    es: 'Algo salió mal al buscar productos destacados.'
  },
  {
    en: 'View All',
    es: 'Mostrar Todo'
  },
  {
    en: 'How can we help you?',
    es: '¿Cómo podemos ayudarlo?'
  },
  {
    en: 'All',
    es: 'Todo'
  },
  {
    en: 'No results found for:',
    es: 'No se encontraron resultados para:'
  },
  {
    en: 'Request a Custom Spec.',
    es: 'Solicitar una Especificación Personalizada.'
  },
  {
    en: 'Don’t see a variation that matches you’re looking for? You can request a custom spec from us with the exact options you want. Just click the button and fill out the form.',
    es: '¿No ve una variación que coincida con lo que está buscando? Puede solicitar una especificación personalizada de nosotros con las opciones exactas que desea. Simplemente haga clic en el botón y complete el formulario.'
  },
  {
    en: 'Request a Custom Spec',
    es: 'Solicitar una Especificación Personalizada'
  },
  {
    en: 'Flushometers',
    es: 'Fluxómetros'
  },
  {
    en: 'Fixtures',
    es: 'Accesorios'
  },
  {
    en: 'Sinks',
    es: 'Lavabos'
  },
  {
    en: 'Faucets',
    es: 'Llaves'
  },
  {
    en: 'More',
    es: 'Más'
  },
  {
    en: 'none',
    es: 'ninguna'
  },
  {
    en: 'Active',
    es: 'Activa'
  },
  {
    en: 'Something went wrong',
    es: 'Algo salió mal'
  },
  {
    en: 'Unable to download',
    es: 'No se puede descargar'
  },
  {
    en: 'Create Account',
    es: 'Crear Cuenta'
  },
  {
    en: 'Project deleted',
    es: 'Proyecto borrado'
  },
  {
    en: 'Password',
    es: 'Contraseña'
  },
  {
    en: 'Forgot password?',
    es: '¿Olvidó su contraseña?'
  },
  {
    en: 'Select All',
    es: 'Seleccionar todo'
  },
  {
    en: 'Spec Sheet',
    es: 'Hoja de Especificaciones'
  },
  {
    en: 'BIM Model',
    es: 'Modelo BIM'
  },
  {
    en: 'CAD Drawing',
    es: 'Dibujo CAD'
  },
  {
    en: 'Installation Instructions',
    es: 'Instrucciones de Instalación'
  },
  {
    en: 'Repair & Maintenance Guide',
    es: 'Guía de Reparación y Mantenimiento'
  },
  {
    en: 'Please enter your full name',
    es: 'Por favor ingrese su nombre completo'
  },
  {
    en: 'Please enter a valid email',
    es: 'Por favor ingrese un correo electrónico válido'
  },
  {
    en: 'Please enter a password',
    es: 'Por favor ingrese una contraseña'
  },
  {
    en: 'Unable to register this account',
    es: 'No se puede registrar esta cuenta'
  },
  {
    en: 'Please enter your email',
    es: 'Por favor ingrese su correo electrónico'
  },
  {
    en: 'Please enter your password',
    es: 'Por favor ingrese su contraseña'
  },
  {
    en: 'Incorrect username or password',
    es: 'Incorrecto nombre de usuario o contraseña'
  },
  {
    en: 'Unable to retrieve projects. Please contact support.',
    es: 'No se pueden recuperar los proyectos. Por favor, póngase en contacto con soporte.'
  },
  {
    en: 'Unable to retrieve cover images',
    es: 'No se pueden recuperar las imágenes de portada'
  },
  {
    en: 'Order history',
    es: 'Historial de órdenes'
  },
  {
    en: 'Returns',
    es: 'Devoluciones'
  },
  {
    en: 'Saved carts',
    es: 'Carritos guardados'
  },
  {
    en: 'Address book',
    es: 'Directorio'
  },
  {
    en: 'Payment details',
    es: 'Detalles del pago'
  },
  {
    en: 'Personal details',
    es: 'Detalles personales'
  },
  {
    en: 'DesignSpec Projects',
    es: 'Proyectos de Especificaciones de Diseño'
  },
  {
    en: 'Sign Out',
    es: 'Cerrar sesión'
  },
  {
    en: 'Sign in to your account',
    es: 'Iniciar sesión en su cuenta'
  },
  {
    en: 'New customer? Create an account.',
    es: '¿Nuevo cliente? Crear una cuenta.'
  },
  {
    en: 'Enjoy these benefits with your new account.',
    es: 'Disfruta de estos beneficios con tu nueva cuenta.'
  },
  {
    en: 'Track your Sloan Marketplace orders',
    es: 'Seguimiento de sus órdenes de Sloan Marketplace'
  },
  {
    en: 'Store and manage addresses',
    es: 'Almacenar y administrar direcciones'
  },
  {
    en: 'Create, view, and share DesignSpec projects',
    es: 'Crear, ver y compartir proyectos de Especificaciones de Diseño'
  },
  {
    en: 'Check your order status',
    es: 'Verifique el estado de su orden'
  },
  {
    en: 'Check on the status of your order, even if you have not registered for an account. Simply fill out the details from an existing order below.',
    es: 'Verifique el estado de su orden, incluso si no se ha registrado para una cuenta. Simplemente complete los detalles de una orden existente a continuación.'
  },
  {
    en: 'My Cart',
    es: 'Mi Carrito'
  },
  {
    en: 'Order History',
    es: 'Historial de Órdenes'
  },
  {
    en: 'Payment Details',
    es: 'Detalles del Pago'
  },
  {
    en: 'Personal Details',
    es: 'Detalles Personales'
  },
  {
    en: 'Address Book',
    es: 'Directorio'
  },
  {
    en: 'Saved Carts',
    es: 'Carritos Guardados'
  },
  {
    en: 'Password must be 8 characters minimum with a mix of lowercase, uppercase, and alphanumeric characters.',
    es: 'La contraseña debe tener un mínimo de 8 caracteres con una combinación de caracteres en minúsculas, mayúsculas y alfanuméricos.'
  },
  {
    en: 'Confirm Password',
    es: 'Confirmar Contraseña'
  },
  {
    en: 'Yes, sign me up to receive emails from Sloan',
    es: 'Sí, suscríbeme para recibir correos electrónicos de Sloan'
  },
  {
    en: 'Please make sure your passwords match',
    es: 'Por favor, asegúrese de que sus contraseñas coinciden'
  },
  {
    en: 'Each',
    es: 'Cada uno'
  },
  {
    en: 'Order Number',
    es: 'Número de Orden'
  },
  {
    en: 'Order Email',
    es: 'Correo Electrónico de Orden'
  },
  {
    en: 'Billing Zip Code',
    es: 'Código Postal de Facturación'
  },
  {
    en: 'Check Status',
    es: 'Verificar Estado'
  },
  {
    en: 'Added to Cart!',
    es: '¡Agregado al Carrito!'
  },
  {
    en: 'Continue Shopping',
    es: 'Seguir Comprando'
  },
  {
    en: 'Proceed to Cart',
    es: 'Proceder al Carrito'
  },
  {
    en: 'You might also like',
    es: 'También podría gustarte'
  },
  {
    en: 'Estimated ship date',
    es: 'Fecha estimada de envío'
  },
  {
    en: 'Price',
    es: 'Precio'
  },
  {
    en: 'items in cart',
    es: 'artículos en el carrito'
  },
  {
    en: 'Your cart is empty.',
    es: 'Su carrito está vacío.'
  },
  {
    en: 'Shop for these Sloan parts and products.',
    es: 'Compre estas partes y productos de Sloan.'
  },
  {
    en: 'Shop Faucet Parts',
    es: 'Comprar Piezas de Llaves'
  },
  {
    en: 'Shop Hand Dryers',
    es: 'Comprar Secadores de Manos'
  },
  {
    en: 'Shop Mobile Handwashing Stations',
    es: 'Comprar Estaciones de Mobile Handwashing'
  },
  {
    en: 'Privacy Policy',
    es: 'Política de Privacidad'
  },
  {
    en: 'Terms of Use',
    es: 'Términos de Uso'
  },
  {
    en: 'Terms of Sale',
    es: 'Términos de Venta'
  },
  {
    en: 'You must add a quantity of at least one for an item.',
    es: 'Debe agregar una cantidad de al menos uno para un artículo.'
  },
  {
    en: 'User information',
    es: 'Información del usuario'
  },
  {
    en: 'First Name',
    es: 'Primer Nombre'
  },
  {
    en: 'Last Name',
    es: 'Apellido'
  },
  {
    en: 'User email',
    es: 'Correo electrónico del usuario'
  },
  {
    en: 'Current email',
    es: 'Correo electrónico actual'
  },
  {
    en: 'New email address',
    es: 'Nuevo correo electrónico'
  },
  {
    en: 'Confirm new email address',
    es: 'Confirmar nuevo correo electrónico'
  },
  {
    en: 'Update password',
    es: 'Actualizar contraseña'
  },
  {
    en: 'Current password',
    es: 'Contraseña actual'
  },
  {
    en: 'New password',
    es: 'Nueva contraseña'
  },
  {
    en: 'Confirm new password',
    es: 'Confirmar nueva contraseña'
  },
  {
    en: 'You have no orders',
    es: 'No tienes órdenes'
  },
  {
    en: 'Shop the following categories for Sloan parts',
    es: 'Compre las siguientes categorías para piezas de Sloan'
  },
  {
    en: 'Find Sloan genuine replacement parts for your products.',
    es: 'Encuentre piezas de repuesto genuinas de Sloan para sus productos.'
  },
  {
    en: 'Completely overhauled to be faster, quieter, and more energy efficient.',
    es: 'Completamente renovado para ser más rápido, más silencioso y más eficiente en energía.'
  },
  {
    en: 'Bring your facility more convenient handwashing options.',
    es: 'Ofrezca a su instalación más opciones de lavado de manos más convenientes.'
  },
  {
    en: 'Shop now',
    es: 'Comprar ahora'
  },
  {
    en: 'You have no returns',
    es: 'No tienes devoluciones'
  },
  {
    en: 'You have no saved carts',
    es: 'No tienes carritos guardados'
  },
  {
    en: 'You have no payment details',
    es: 'No tienes detalles de pago'
  },
  {
    en: 'You have no',
    es: 'No tienes'
  },
  {
    en: 'orders',
    es: 'órdenes'
  },
  {
    en: 'returns',
    es: 'devoluciones'
  },
  {
    en: 'saved carts',
    es: 'carritos guardados'
  },
  {
    en: 'Add New Address',
    es: 'Agregar Nueva Dirección'
  },
  {
    en: 'Add New Payment',
    es: 'Agregar Nuevo Pago'
  },
  {
    en: 'Reason',
    es: 'Razón'
  },
  {
    en: 'Showing ',
    es: 'Mostrando '
  },
  {
    en: 'Result',
    es: 'Resultado'
  },
  {
    en: 'Open',
    es: 'Abierto'
  },
  {
    en: 'Shipped',
    es: 'Enviado'
  },
  {
    en: 'Cancelled',
    es: 'Cancelado'
  },
  {
    en: 'Return Order Number',
    es: 'Número de Orden de Devolución'
  },
  {
    en: 'Date Placed',
    es: 'Fecha de Pedido'
  },
  {
    en: 'Items',
    es: 'Artículos'
  },
  {
    en: 'Total',
    es: 'Total'
  },
  {
    en: 'more items',
    es: 'más artículos'
  },
  {
    en: 'Collapse',
    es: 'Colapso'
  },
  {
    en: 'Purchased from',
    es: 'Comprado de'
  },
  {
    en: 'Order',
    es: 'Orden'
  },
  {
    en: 'Subtotal',
    es: 'Subtotal'
  },
  {
    en: 'Shipping',
    es: 'Envío'
  },
  {
    en: 'Tax',
    es: 'Impuesto'
  },
  {
    en: 'Need help? Contact us',
    es: '¿Necesita ayuda? Contáctenos'
  },
  {
    en: 'or call us toll free',
    es: 'o llámenos gratis'
  },
  {
    en: 'Code',
    es: 'Código'
  },
  {
    en: 'One uppercase character',
    es: 'Un carácter en mayúscula'
  },
  {
    en: 'One lowercase character',
    es: 'Un carácter en minúscula'
  },
  {
    en: 'One number',
    es: 'Un número'
  },
  {
    en: '8 characters minimum',
    es: '8 caracteres mínimo'
  },
  {
    en: 'Reset password',
    es: 'Restablecer contraseña'
  },
  {
    en: 'Please enter your email to reset your password.',
    es: 'Ingrese su correo electrónico para restablecer su contraseña.'
  },
  {
    en: 'Add to cart',
    es: 'Agregar al carrito'
  },
  {
    en: 'Cart',
    es: 'Carrito'
  },
  {
    en: 'Search orders',
    es: 'Buscar órdenes'
  },
  {
    en: 'Please enter a new password.',
    es: 'Por favor ingrese una nueva contraseña.'
  },
  {
    en: 'Please enter your first name',
    es: 'Por favor ingrese su nombre'
  },
  {
    en: 'Please enter your last name',
    es: 'Por favor ingrese su apellido'
  },
  {
    en: 'Passwords must match',
    es: 'Las contraseñas deben coincidir'
  },
  {
    en: 'Please enter your new password.',
    es: 'Por favor ingrese su nueva contraseña.'
  },
  {
    en: 'Email does not exist in our system',
    es: 'El correo electrónico no existe en nuestro sistema'
  },
  {
    en: 'Remove',
    es: 'Eliminar'
  },
  {
    en: 'Secure Checkout',
    es: 'Pago Seguro'
  },
  {
    en: 'Order Summary',
    es: 'Resumen de Orden'
  },
  {
    en: 'Edit Order',
    es: 'Editar Orden'
  },
  {
    en: 'Contact Information',
    es: 'Información de Contacto'
  },
  {
    en: 'Information',
    es: 'Información'
  },
  {
    en: 'Payment',
    es: 'Pago'
  },
  {
    en: 'Review',
    es: 'Revisión'
  },
  {
    en: 'Checkout as guest',
    es: 'Pagar como invitado'
  },
  {
    en: 'Clear Cart',
    es: 'Vaciar carrito'
  },
  {
    en: 'View saved carts',
    es: 'Ver carritos guardados'
  },
  {
    en: 'Save cart for later',
    es: 'Guardar carrito para más tarde'
  },
  {
    en: 'Save this cart?',
    es: '¿Guardar este carrito?'
  },
  {
    en: 'All of the items in your cart will be saved for later and can be accessed in your account.',
    es: 'Todos los artículos en su carrito se guardarán para más adelante y se podrá acceder a ellos en su cuenta.'
  },
  {
    en: 'Cart name',
    es: 'Nombre del carrito'
  },
  {
    en: 'Clear cart?',
    es: '¿Vaciar carrito?'
  },
  {
    en: 'All items in your cart will be deleted.',
    es: 'Todos los artículos en su carrito serán eliminados.'
  },
  {
    en: 'Date Saved',
    es: 'Fecha guardada'
  },
  {
    en: 'Make Active',
    es: 'Hacer Activo'
  },
  {
    en: 'Delete Cart',
    es: 'Eliminar Carrito'
  },
  {
    en: 'Make cart active',
    es: 'Hacer carrito activo'
  },
  {
    en: 'By making this cart active your current cart will be lost.',
    es: 'Al activar este carrito, perderá su carrito actual.'
  },
  {
    en: 'Are you sure you want to delete this saved cart?',
    es: '¿Estás seguro de que quieres eliminar este carro guardado?'
  },
  {
    en: 'Yes, make cart active',
    es: 'Sí, hacer carrito activo'
  },
  {
    en: 'No, keep my current cart',
    es: 'No, mantener mi carrito actual'
  },
  {
    en: 'Yes, delete saved cart',
    es: 'Sí, eliminar carrito guardado'
  },
  {
    en: 'No, keep my saved cart',
    es: 'No, mantener mi carrito guardado'
  },
  {
    en: 'Unable to make cart active',
    es: 'No se puede hacer carrito activo'
  },
  {
    en: 'Unable to delete saved cart',
    es: 'No se puede eliminar carrito guardado'
  },
  {
    en: 'Continue',
    es: 'Continuar'
  },
  {
    en: 'Shipping Address',
    es: 'Dirección de Envío'
  },
  {
    en: 'Attention (optional)',
    es: 'Atención (opcional)'
  },
  {
    en: 'Company Name (optional)',
    es: 'Nombre de Empresa (opcional)'
  },
  {
    en: 'Phone (optional)',
    es: 'Teléfono (opcional)'
  },
  {
    en: 'Country',
    es: 'País'
  },
  {
    en: 'Zip Code',
    es: 'Código Postal'
  },
  {
    en: 'Back',
    es: 'Regresa'
  },
  {
    en: 'Shipping Method',
    es: 'Método de Envío'
  },
  {
    en: 'Consolidate Shipping',
    es: 'Consolidar Envío'
  },
  {
    en: 'Leave checked to receive orders in as few shipments as possible.',
    es: 'Déjelo marcado para recibir los pedidos en el menor número de envíos posible.'
  },
  {
    en: 'No shipping methods available',
    es: 'No hay métodos de envío disponibles'
  },
  {
    en: 'An error occurred while selecting the shipping method.',
    es: 'Ocurrió un error al seleccionar el método de envío.'
  },
  {
    en: 'Estimated Delivery',
    es: 'Entrega Estimada'
  },
  {
    en: 'Change',
    es: 'Cambiar'
  },
  {
    en: 'Update',
    es: 'Actualizar'
  },
  {
    en: 'Shipping to US only',
    es: 'Envío solo a EE. UU.'
  },
  {
    en: 'Hello',
    es: '¡Hola'
  },
  {
    en: 'Estimated Ship Date',
    es: 'Fecha de Envío Estimada'
  },
  {
    en: 'Payment Method',
    es: 'Método de Pago'
  },
  {
    en: 'Add New Payment Method',
    es: 'Agregar Nuevo Método de Pago'
  },
  {
    en: 'Continue to Review',
    es: 'Continuar a Revisión'
  },
  {
    en: 'Customer PO Number',
    es: 'Número de Orden de Cliente'
  },
  {
    en: 'Customer PO Number (optional)',
    es: 'Número de Orden de Cliente (opcional)'
  },
  {
    en: 'Billing Address',
    es: 'Dirección de Facturación'
  },
  {
    en: 'New payment details',
    es: 'Nuevos detalles de pago'
  },
  {
    en: 'Save payment details to my account',
    es: 'Guardar detalles de pago en mi cuenta'
  },
  {
    en: 'Same as shipping address',
    es: 'Igual que la dirección de envío'
  },
  {
    en: 'Save this address to my account',
    es: 'Guardar esta dirección en mi cuenta'
  },
  {
    en: 'New',
    es: 'Nuevo'
  },
  {
    en: 'I have read and agreed with the',
    es: 'He leído y aceptado el'
  },
  {
    en: 'and',
    es: 'y'
  },
  {
    en: 'Place order',
    es: 'Realizar pedido'
  },
  {
    en: 'Thank you',
    es: '¡Gracias'
  },
  {
    en: 'Order #',
    es: 'Orden #'
  },
  {
    en: 'Your order is confirmed',
    es: 'Su pedido está confirmado'
  },
  {
    en: 'You will receive a confirmation email shortly.',
    es: 'Recibirá un correo electrónico de confirmación en breve.'
  },
  {
    en: 'Contact',
    es: 'Contacto'
  },
  {
    en: 'Need Help? Contact us',
    es: '¿Necesita ayuda? Contáctenos'
  },
  {
    en: 'or call us toll free',
    es: 'o llámenos gratis'
  },
  {
    en: 'Thank you for your order!',
    es: '¡Gracias por su orden!'
  },
  {
    en: 'You are already logged in, proceed with checkout.',
    es: 'Ya ha iniciado sesión, continúe con el pago.'
  },
  {
    en: 'There was an error loading your addresses. Please try again.',
    es: 'Hubo un error al cargar sus direcciones. Inténtelo de nuevo.'
  },
  {
    en: 'There was an error adding your shipping address.',
    es: 'Hubo un error al agregar su dirección de envío.'
  },
  {
    en: 'Your shipping address has been updated.',
    es: 'Su dirección de envío ha sido actualizada.'
  },
  {
    en: 'Unable to update your shipping address.',
    es: 'No se pudo actualizar su dirección de envío.'
  },
  {
    en: 'Invalid address provided.',
    es: 'Dirección no válida proporcionada.'
  },
  {
    en: 'Please select a shipping method.',
    es: 'Seleccione un método de envío.'
  },
  {
    en: 'We are unable to process payments at this time.',
    es: 'No podemos procesar pagos en este momento.'
  },
  {
    en: 'Unable to select payment option.',
    es: 'No se puede seleccionar la opción de pago.'
  },
  {
    en: 'Invalid address provided.',
    es: 'Dirección no válida proporcionada.'
  },
  {
    en: 'Invalid credit card credentials provided.',
    es: 'Se proporcionaron credenciales de tarjeta de crédito no válidas.'
  },
  {
    en: 'Your name has been updated successfully!',
    es: '¡Su nombre se ha actualizado con éxito!'
  },
  {
    en: 'Your password has been updated successfully!',
    es: '¡Su contraseña se ha actualizado con éxito!'
  },
  {
    en: 'default',
    es: 'predeterminado'
  },
  {
    en: 'Make Default',
    es: 'Hacer predeterminado'
  },
  {
    en: 'Saved Payment Methods',
    es: 'Métodos de Pago Guardados'
  },
  {
    en: 'Saved Addresses',
    es: 'Direcciones Guardadas'
  },
  {
    en: 'Currently shipping to US only.',
    es: 'Actualmente enviamos solo a EE. UU.'
  },
  {
    en: 'New password does not match confirm',
    es: 'La nueva contraseña no coincide con la confirmación'
  },
  {
    en : 'Old password',
    es : 'Contraseña anterior'
  },
  {
    en: 'Updating your email address will sign you out and you will be redirected to the sign in page.',
    es: 'Si actualiza su dirección de correo electrónico, cerrará su sesión y será redirigido a la página de inicio de sesión.'
  },
  {
    en: 'New email does not match confirm',
    es: 'El nuevo correo electrónico no coincide con la confirmación'
  },
  {
    en: 'Updating your password will sign you out and redirected to the sign in page.',
    es: 'Si actualiza su contraseña, cerrará su sesión y será redirigido a la página de inicio de sesión.'
  },
  {
    en: 'Showing',
    es: 'Mostrando'
  },
  {
    en: 'results',
    es: 'resultados'
  },
  {
    en: 'result',
    es: 'resultado'
  },
  {
    en: 'Reorder item',
    es: 'Reordenar artículo'
  },
  {
    en: 'Reorder',
    es: 'Reordenar'
  },
  {
    en: 'View order',
    es: 'Ver orden'
  },
  {
    en: 'Reorder this cart?',
    es: '¿Reordenar este carrito?'
  },
  {
    en: 'By reordering these products, your existing cart will be replaced with this reorder unless you save your current cart. Any products currently in your cart will be lost.',
    es: 'Al reordenar estos productos, su carrito existente se reemplazará con esta reordenación, a menos que guarde su carrito actual. Cualquier producto actualmente en su carrito se perderá.'
  },
  {
    en: 'By reordering this item it will add this item and it\'s original quantity to your existing cart.',
    es: 'Al reordenar este artículo, agregará este artículo y su cantidad original a su carrito existente.'
  },
  {
    en: 'Yes, proceed to reorder',
    es: 'Sí, proceder a reordenar'
  },
  {
    en: 'Last 3 months',
    es: 'Últimos 3 meses'
  },
  {
    en: 'Last 6 months',
    es: 'Últimos 6 meses'
  },
  {
    en: 'Last 12 months',
    es: 'Últimos 12 meses'
  },
  {
    en: 'All transactions',
    es: 'Todas las transacciones'
  },
  {
    en: 'Print order',
    es: 'Imprimir orden'
  },
  {
    en: 'Return order',
    es: 'Orden de devolución'
  },
  {
    en: 'Estimated shipping date',
    es: 'Fecha de envío estimada'
  },
  {
    en: 'Purchased from Sloan Marketplace',
    es: 'Comprado en Sloan Marketplace'
  },
  {
    en: 'Cancel order',
    es: 'Cancelar orden'
  },
  {
    en: 'First',
    es: 'Primero'
  },
  {
    en: 'Last',
    es: 'Último'
  },
  {
    en: 'Returned items',
    es: 'Artículos devueltos'
  },
  {
    en: 'Track Shipment',
    es: 'Seguimiento de envío'
  },
  {
    en: 'Notes',
    es: 'Notas'
  },
  {
    en: 'View Details',
    es: 'Ver detalles'
  },
  {
    en: 'Reorder this item?',
    es: '¿Reordenar este artículo?'
  },
  {
    en: 'No, do not reorder',
    es: 'No, no reordenar'
  },
  {
    en: 'Cancel this entire order?',
    es: '¿Cancelar esta orden completa?'
  },
  {
    en: 'Please let us know why you would like to cancel this order.',
    es: 'Por favor, háganos saber por qué desea cancelar este pedido.'
  },
  {
    en: 'Cancellation reason',
    es: 'Motivo de cancelación'
  },
  {
    en: 'Yes, cancel my order',
    es: 'Sí, cancelar mi pedido'
  },
  {
    en: 'No, keep my order',
    es: 'No, mantener mi pedido'
  },
  {
    en: 'Please select',
    es: 'Por favor selecciona'
  },
  {
    en: 'Where to Buy',
    es: 'Dónde comprar'
  },
  {
    en: 'Invalid email or password.',
    es: 'Correo electrónico o contraseña no válidos.'
  },
  {
    en: 'This is the string: Incorrect credentials. Account locked after too many failed attempts. Reset your password to unlock your account.',
    es: 'Credenciales incorrectas. Cuenta bloqueada después de demasiados intentos fallidos. Restablezca su contraseña para desbloquear su cuenta.'
  },
  {
    en: 'View a complete list of Compliances & Certifications for each product below',
    es: 'Vea una lista completa de Cumplimientos y Certificaciones para cada producto a continuación'
  },
  {
    en: 'Please complete the reCAPTCHA',
    es: 'Por favor completa el reCAPTCHA'
  },
  {
    en: 'Some products in your DesignSpec project have been discontinued and were removed.',
    es: 'Algunos productos en su proyecto DesignSpec han sido descontinuados y se han eliminado.'
  },
  {
    en: 'Marketplace Cart Trigger',
    es: 'Activador de carrito de Marketplace'
  },
  {
    en: 'The following items in your cart require your attention.',
    es: 'Los siguientes artículos en su carrito requieren su atención.'
  },
  {
    en: 'Please see below to update the items in your cart.',
    es: 'Por favor consulte a continuación para actualizar los artículos en su carrito.'
  },
  {
    en: 'WARNING California Residents',
    es: 'ADVERTENCIA Residentes de California'
  },
  {
    en: 'see Prop 65 warnings',
    es: 'ver advertencias de Prop 65'
  },
  {
    en: 'This product can expose you to chemicals including lead which is known to the State of California to cause cancer and birth defects or other reproductive harm.',
    es: 'Este producto puede exponerlo a productos químicos, incluido el plomo, que es conocido por el Estado de California como causante de cáncer y defectos de nacimiento u otros daños reproductivos.'
  },
  {
    en: 'For further details, please visit',
    es: 'Para más detalles, por favor visite'
  },
  {
    en: 'Shop Parts',
    es: 'Comprar Partes'
  },
  {
    en: 'Shop Mirrors',
    es: 'Comprar Espejos'
  },
  {
    en: 'The perfect reflection of your design.',
    es: 'La reflexión perfecta de su diseño.'
  }
];
